import { gql } from '@apollo/client'

const EDIT_REFERRAL_SUB_SOURCE = gql`
  mutation EDIT_REFERRAL_SUB_SOURCE(
    $referralSubSource: ID!
    $name: String!
    $order: Int
    $color: String!
    $referralUrl: String
    $referralId: String
  ) {
    editReferralSubSource(
      referralSubSource: $referralSubSource
      name: $name
      order: $order
      color: $color
      referralUrl: $referralUrl
      referralId: $referralId
    ) {
      id
      name
      order
      color
      referralUrl
      referralId
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`

export default EDIT_REFERRAL_SUB_SOURCE
